module.exports = __webpack_public_path__ + "img/wenyanming.70cc41f6.jpg";